import { getPlatforms } from "@ionic/vue";
import { Capacitor } from "@capacitor/core";

import { PLATFORM_TYPE } from "@/Modules/App/Models/Domain/AppState";

import { config } from "@/Common/envConfig";

export const isApp = () => {
  const platforms = getPlatforms();

  return (
    platforms.includes("capacitor") ||
    platforms.includes("cordova") ||
    ["ios", "android"].includes(Capacitor.getPlatform()) ||
    config.forceAppMode === "app" ||
    config.forceAppMode === "ios" ||
    config.forceAppMode === "android"
  );
};

export const isIosApp = () => (isApp() && getPlatforms().includes("ios")) || config.forceAppMode === "ios";

export const isAndroidApp = () => {
  return (isApp() && getPlatforms().includes("android")) || config.forceAppMode === "android";
};

export const isIos = () => getPlatforms().includes("ios");
export const isAndroid = () => getPlatforms().includes("android");

export const platformType = () => {
  if (isIosApp()) return PLATFORM_TYPE.IOS;
  else if (isAndroidApp()) return PLATFORM_TYPE.ANDROID;
  else {
    const platforms = getPlatforms();

    if (platforms.includes("mobile")) return PLATFORM_TYPE.WEB_MOBILE;
    else {
      return PLATFORM_TYPE.WEB_DESKTOP;
    }
  }
};

export const platforms = () => getPlatforms();
